import { FiltroService } from './../../../shared/filtro/filtro.service';
import { DatePipe, ViewportScroller } from '@angular/common';
import { Component, ElementRef, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { MessageService } from 'primeng/api';
import { Table } from 'primeng/table';
import { ExportExcelService } from '../../../shared/excel-service/export-excel.service';
import { BiRelatorioTaxaFiltroService } from './bi-relatorio-taxa-filtro.service';
import { BiRelatorioTaxaService } from './bi-relatorio-taxa.service';
import { FiltroDealers } from './filtro-dealer';

@Component({
  selector: 'app-bi-relatorio-taxa',
  templateUrl: './bi-relatorio-taxa.component.html',
  styleUrls: ['./bi-relatorio-taxa.component.scss']
})
export class BiRelatorioTaxaComponent implements OnInit {
  @Input() filtros: any;

  form: FormGroup;

  registros: any[] = [];
  registrosAnalitico: any[] = [];

  columnsSynthetic: any[];
  _selectedColumnsSynthetic: any[];

  columnsAnalytical: any[];
  _selectedColumnsAnalytical: any[];

  dataInicial: Date;
  dataFinal: Date;
  nomeModulo: string;
  nomeModuloAnalitico: string;
  textoComment: string = "";
  textoMessage: string = "";
  cargaTela: boolean;

  first: number = 0;
  displayRows: number = 0;
  rows: number = 10;
  totalRecords: number = 0;

  firstAn: number = 0;
  displayRowsAn: number = 0;
  rowsAn: number = 10;
  totalRecors: number = 0;

  maxDate: Date = new Date();

  filtrosDealers: FiltroDealers;

  displayFiltrosDealers: boolean = false;
  displayComentarios: boolean = false;
  displayMensagens: boolean = false;
  displayFiltros: boolean = false;
  carregando: boolean = false;
  loading: boolean = false;
  filtrado: boolean = false;

  nomeTotais: any;
  totalSolicitadas: number = 0
  totalAtendidas: number = 0
  totalNAtendidas: number = 0
  totalPercentual: number = 0

  gruposEconomicos = [];
  classificacao = [];

  @ViewChild('dt') dt: Table;
  @ViewChildren('dealers') dealers: QueryList<ElementRef>;

  dadosTranslate = {
    "Dealers": "businessIntelligence.relatorioTaxa.gridHeader.dealers",
    "Nome": "businessIntelligence.relatorioTaxa.gridHeader.nome",
    "Interface": "businessIntelligence.relatorioTaxa.gridHeader.interface",
    "Sucesso": "businessIntelligence.relatorioTaxa.gridHeader.sucesso",
    "Erro": "businessIntelligence.relatorioTaxa.gridHeader.erro",
    "chassi": "businessIntelligence.relatorioTaxa.gridHeader.chassi",
    "quilometragem": "businessIntelligence.relatorioTaxa.gridHeader.quilometragem",
    "comentários": "businessIntelligence.relatorioTaxa.gridHeader.comentarios",
    "Mensagem": "businessIntelligence.relatorioTaxa.gridHeader.mensagem",
    "tipoServico": "businessIntelligence.relatorioTaxa.gridHeader.tipoServico",
    "dataFechamentoOs": "businessIntelligence.relatorioTaxa.gridHeader.dataFechamentoOs"
  }

  constructor(private service: BiRelatorioTaxaService,
    private translate: TranslateService,
    private servico: BiRelatorioTaxaFiltroService,
    private exportExcelService: ExportExcelService,
    private messageService: MessageService,
    private fb: FormBuilder,
    private date: DatePipe,
    private viewportScroller: ViewportScroller,
    private detalhado: FiltroService) {
    this.filtros = {};
    this.nomeModulo = 'Relatório Taxa Serviço';
    this.nomeModuloAnalitico = 'Relatório Taxa Serviço - Detalhe';
    this.filtrosDealers = new FiltroDealers(this.servico);
    this.tratarData();

    this.form = this.fb.group({
      data_inicial: [moment(this.dataInicial).format('DD-MM-YYYY')],
      data_final: [moment(this.dataFinal).format('DD-MM-YYYY')],
      dealer: [''],
      codigo: [''],
      grupo_economico: [''],
      numeroOS: [''],
      codItem: [''],
      classificacao: [''],
    });

    this.maxDate.setDate(this.maxDate.getDate());
  }

  ngOnInit() {
    this.preencherGruposEconomicos();
    this.preencherClassificacao();
    this.columnsSynthetic = [
      { field: 'dealer', header: 'businessIntelligence.relatorioTaxa.gridHeader.dealers' },
      { field: 'nome', header: 'businessIntelligence.relatorioTaxa.gridHeader.nome' },
      { field: 'solicitadas', header: 'businessIntelligence.relatorioTaxa.gridHeader.solicitadas' },
      { field: 'atendidas', header: 'businessIntelligence.relatorioTaxa.gridHeader.atendidas' },
      { field: 'natendidas', header: 'businessIntelligence.relatorioTaxa.gridHeader.natendidas' },
      { field: 'percentual', header: 'businessIntelligence.relatorioTaxa.gridHeader.percentual' },
    ];

    this.columnsAnalytical = [
      { field: 'dealer', header: 'businessIntelligence.relatorioTaxa.gridHeader.dealers' },
      { field: 'numeroOs', header: 'businessIntelligence.relatorioTaxa.gridHeader.numeroOs' },
      { field: 'idNumeroOs', header: 'businessIntelligence.relatorioTaxa.gridHeader.idNumeroOS' },
      { field: 'codItem', header: 'businessIntelligence.relatorioTaxa.gridHeader.codItem' },
      { field: 'descricaoItem', header: 'businessIntelligence.relatorioTaxa.gridHeader.descricaoItem' },
      { field: 'dataRequisicao', header: 'businessIntelligence.relatorioTaxa.gridHeader.dataRequisicao' },
      { field: 'solicitadas', header: 'businessIntelligence.relatorioTaxa.gridHeader.solicitadas' },
      { field: 'atendidas', header: 'businessIntelligence.relatorioTaxa.gridHeader.atendidas' },
    ];

    this._selectedColumnsSynthetic = this.columnsSynthetic;
    this._selectedColumnsAnalytical = this.columnsAnalytical;

    this.filtrosDealers.carregar();
    this.getAll();
    this.limparFiltros();
  }

  @Input() get selectedColumnsSynthetic(): any[] {
    return this._selectedColumnsSynthetic;
  }

  @Input() get selectedColumnsAnalytical(): any[] {
    return this._selectedColumnsAnalytical;
  }

  set selectedColumnsSynthetic(val: any[]) {    
    this._selectedColumnsSynthetic = this.columnsSynthetic.filter(col => val.includes(col));
  }

  set selectedColumnsAnalytical(val: any[]) {
    this._selectedColumnsAnalytical = this.columnsAnalytical.filter(col => val.includes(col));
  }

  get f() { return this.form.controls; }

  private shouldShowIdNumeroOs(rows: any[]): boolean {
    // mostra a coluna se existir ao menos 1 linha onde idNumeroOs != null 
    // E idNumeroOs != numeroOs
    return rows?.some(d =>
      d?.idNumeroOs != null &&
      d?.idNumeroOs !== undefined &&
      d?.idNumeroOs !== '' &&
      d?.numeroOs != null &&
      String(d.idNumeroOs) !== String(d.numeroOs)
    );
  }

  private getAll() {
    this.loading = true;

    if (this.f.data_inicial.value == "Invalid date") {
      const now = new Date();
      this.f.data_inicial.setValue(now.toLocaleDateString());
    }

    if (this.f.data_final.value == "Invalid date") {
      const now = new Date();
      this.f.data_final.setValue(now.toLocaleDateString());
    }

    this.service.getDados(this.f.data_inicial.value, this.f.data_final.value, this.f.dealer.value,
      this.f.grupo_economico.value, this.f.numeroOS.value, this.f.codItem.value, this.f.classificacao.value).subscribe(res => {
        this.registros = res.dados;
        this.calculandoTotal(res);

        this.loading = false;
        this.carregando = false;
      });
  }

  calculandoTotal(res) {
    this.nomeTotais = 'Brasil';
    this.totalSolicitadas = res.totalSolicitadas;
    this.totalAtendidas = res.totalAtendidas;
    this.totalNAtendidas = res.totalNAtendidas;
    this.totalPercentual = res.totalPercentual;
  }


  private getAllAnalitico() {
    this.loading = true;

    this.service.getDadosAnaliticos(this.f.codigo.value, this.f.data_inicial.value, this.f.data_final.value,
      this.f.grupo_economico.value, this.f.numeroOS.value, this.f.codItem.value, this.f.classificacao.value).subscribe(res => {
        this.registrosAnalitico = res.dados ?? [];

        // NÃO altere idNumeroOs aqui; deixe null como null.

        // decide se mostra/oculta a coluna
        const exibirIdNumeroOs = this.shouldShowIdNumeroOs(this.registrosAnalitico);
        if (!exibirIdNumeroOs) {
          // remove a coluna quando não há retorno do back-end ou todos são iguais/null
          this._selectedColumnsAnalytical = this.columnsAnalytical.filter(c => c.field !== 'idNumeroOs');
        } else {
          // garante que a coluna exista logo após numeroOs
          if (!this._selectedColumnsAnalytical.find(c => c.field === 'idNumeroOs')) {
            const idCol = this.columnsAnalytical.find(c => c.field === 'idNumeroOs');
            const idxNumero = this._selectedColumnsAnalytical.findIndex(c => c.field === 'numeroOs');
            if (idCol) {
              if (idxNumero >= 0) {
                const semId = this._selectedColumnsAnalytical.filter(c => c.field !== 'idNumeroOs');
                semId.splice(idxNumero + 1, 0, idCol);
                this._selectedColumnsAnalytical = semId;
              } else {
                this._selectedColumnsAnalytical = [...this._selectedColumnsAnalytical, idCol];
              }
            }
          }
        }

        this.loading = false;
      });

    if (!this.filtrado) {
      setTimeout(() => { this.viewportScroller.scrollToAnchor('target'); }, 300);
    }
  }

  public selecionarDealer() {
    this.displayFiltrosDealers = true;
  }

  public abrirComentarios(index) {
    this.displayComentarios = true;
    this.textoComment = this.registrosAnalitico[index].description;
  }

  public abrirMensagens(index) {
    this.displayMensagens = true;
    this.textoMessage = this.registrosAnalitico[index].message;
  }

  public fecharComentarios() {
    this.displayComentarios = false;
    this.textoComment = "";
  }

  public fecharMensagens() {
    this.displayMensagens = false
    this.textoMessage = "";
  }

  protected removerDealer(dealer: any) {
    dealer.selecionado = false;
    const index = this.filtros.dealers;
    if (index > -1) {
      this.filtros.dealers.splice(index, dealer);
      this.filtrosSelecionados();
    }
  }

  public onAdicionarDealerFiltro(dealer: any) {
    dealer.selecionado = true;
    const sel = [];

    this.incluirFiltroDealers(sel);
    this.filtros.dealers = sel;
  }

  private incluirFiltroDealers(filtros: any[]) {
    if (this.filtrosDealers.selecionados().length > 0) {
      const item = { 'chave': 'dealers', 'valor': [] };
      this.filtrosDealers.selecionados().forEach(element => {
        item.valor.push(element.id);
      });
      filtros.push(item);
    }
  }

  private tratarData() {
    const dataInicio = new Date();
    const dataFim = new Date();

    let firstDay = new Date(dataInicio.getFullYear(), dataInicio.getMonth(), 1);

    this.dataInicial = firstDay;
    this.dataFinal = dataFim;
  }

  public filtroAPI() {
    this.carregando = true;
    this.filtrado = true;

    this.f.data_inicial.setValue(moment(this.dataInicial).format('DD-MM-YYYY'));
    this.f.data_final.setValue(moment(this.dataFinal).format('DD-MM-YYYY'));

    this.filtrosSelecionados();
    this.getAll();

    if (this.registrosAnalitico.length != 0) {
      this.getAllAnalitico();
    }
  }

  private filtrosSelecionados() {
    const dealers = [];

    this.incluirFiltroDealers(dealers);

    this.filtros.dealers = dealers.map(r => r.valor);

    if (this.filtros.dealers.length != 0) {
      this.f.dealer.setValue(this.filtros.dealers[0]);
      this.registrosAnalitico.length = 0;
    } else {
      this.f.dealer.setValue('');
      this.registrosAnalitico.length = 0;
    }
  }

  public limpaDataInicial() {
    const dataInicio = new Date();
    this.dataInicial = new Date(dataInicio.getUTCFullYear(), dataInicio.getMonth(), 1);
  }

  public limpaDataFinal() {
    const dataFim = new Date();
    this.dataFinal = new Date(dataFim.getFullYear(), dataFim.getMonth(), dataFim.getDate());
  }

  public limparFiltros() {
    this.tratarData();

    if (this.filtros.dealers != undefined) {
      this.filtros.dealers.length = 0;
    }

    this.dealers.forEach(item => {
      let el: HTMLElement = item.nativeElement;
      el.click();
    });

    this.f.dealer.setValue('');
    this.f.grupo_economico.setValue('');
    this.f.numeroOS.setValue('');
    this.f.codItem.setValue('');
    this.f.classificacao.setValue('');
  }

  public exportExcel() {
    let registros = [];
    let registrosAnalitico = [];

    this.service.getDados(this.f.data_inicial.value, this.f.data_final.value, this.f.dealer.value,
      this.f.grupo_economico.value, this.f.numeroOS.value, this.f.codItem.value, this.f.classificacao.value).subscribe(res => {
        registros = res.dados;

        if (registros.length > 0) {
          this.exportExcelService.nomeModulo = this.nomeModulo;
          this.exportExcelService.ExportTOExcelJSON(registros.map(r => {
            let linha = {};

            this._selectedColumnsSynthetic.forEach(c => {
              linha[this.translateHeader(c.header)] = this.translateField(r[c.field]);
            });

            return linha;
          }));
        }
      });

    if (this.registrosAnalitico.length != 0) {
      this.service.getDadosAnaliticos(this.f.codigo.value, this.f.data_inicial.value, this.f.data_final.value,
        this.f.grupo_economico.value, this.f.numeroOS.value, this.f.codItem.value, this.f.classificacao.value).subscribe(res => {
          registrosAnalitico = res.dados;

          registrosAnalitico.forEach(element => {
            element.dataRequisicao = element.dataRequisicao.substr(0, 10);
            if (this.translate.currentLang == 'br') {
              element.dataRequisicao = moment(element.dataRequisicao).format('DD/MM/YYYY');
            } else if (this.translate.currentLang == 'gb') {
              element.dataRequisicao = moment(element.dataRequisicao).format('YYYY/MM/DD');
            }
            // NÃO altere idNumeroOs aqui; deixe null como null.
          });

          if (registrosAnalitico.length > 0) {
            this.exportExcelService.nomeModulo = this.nomeModuloAnalitico;
            this.exportExcelService.ExportTOExcelJSON(registrosAnalitico.map(r => {
              let linha = {};

              this._selectedColumnsAnalytical.forEach(c => {
                linha[this.translateHeader(c.header)] = this.translateField(r[c.field]);
              });

              return linha;
            }));
          }
        });
    }
  }

  protected translateHeader(item) {
    if (item == "businessIntelligence.relatorioTaxa.gridHeader.dealers") {
      return "Dealers";
    }
    if (item == "businessIntelligence.relatorioTaxa.gridHeader.nome") {
      return this.translate.currentLang == "br" ? "Nome" : "Name";
    }
    if (item == "businessIntelligence.relatorioTaxa.gridHeader.solicitadas") {
      return this.translate.currentLang == "br" ? "Solicitadas" : "Requested";
    }
    if (item == "businessIntelligence.relatorioTaxa.gridHeader.atendidas") {
      return this.translate.currentLang == "br" ? "Atendidas" : "Serviced";
    }
    if (item == "businessIntelligence.relatorioTaxa.gridHeader.natendidas") {
      return this.translate.currentLang == "br" ? "Não atendidas" : "Unanswered";
    }
    if (item == "businessIntelligence.relatorioTaxa.gridHeader.numeroOs") {
      return this.translate.currentLang == "br" ? "Número OS" : "OS Number";
    }
    if (item == "businessIntelligence.relatorioTaxa.gridHeader.idNumeroOS") {
      return this.translate.currentLang == "br" ? "ID Número OS" : "ID O.S Number";
    }
    if (item == "businessIntelligence.relatorioTaxa.gridHeader.codItem") {
      return this.translate.currentLang == "br" ? "Código do produto" : "Product code";
    }
    if (item == "businessIntelligence.relatorioTaxa.gridHeader.descricaoItem") {
      return this.translate.currentLang == "br" ? "Descrição" : "Description";
    }
    if (item == "businessIntelligence.relatorioTaxa.gridHeader.dataRequisicao") {
      return this.translate.currentLang == "br" ? "Data da requisição" : "Request date";
    }
  }

  protected translateField(item) {
    return item;
  }

  protected getTranslate(value) {
    if (value.nome === "Calculando...") {
      return (value.nome = "businessIntelligence.relatorioTaxa.calculando");
    }

    return this.dadosTranslate[value];
  }

  public getDealerCode(index) {
    this.filtrado = false;

    if (this.registros[index] != null) {
      this.f.codigo.setValue(this.registros[index].dealer);
      if (this.registros[index].errorsQuantity != 0) {
        this.getAllAnalitico();
      } else {
        this.registrosAnalitico.length = 0;
      }
    } else {
      this.f.codigo.setValue(0);
      this.getAllAnalitico();
    }
  }

  public getListagemComFiltros(): boolean {
    return this.f.grupo_economico.value
      || this.f.numeroOS.value
      || this.f.codItem.value
      || this.f.classificacao.value;
  }

  private preencherGruposEconomicos() {
    this.detalhado.buscar('grupo_economico')
      .then(r => { this.gruposEconomicos = r.filtros; });
  }

  private preencherClassificacao() {
    this.classificacao = [
      { descricao: 'Manutenção', id: "MANUTENCAO" },
      { descricao: 'Alto Giro', id: "GIRO" },
      { descricao: 'Campanhas', id: "CAMPANHA" },
      { descricao: 'Peças Estratégicas', id: "PECA" },
      { descricao: 'Não Classificados', id: null },
    ];
  }

  public exibirFiltro() {
    this.displayFiltros = true;
  }
}